export default "__VITE_ASSET__61df1b03__"